import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {UsernamePasswordService} from './username-password.service';
import {AppPaths} from '../../../../enums/app-paths';
import {NzFormModule} from "ng-zorro-antd/form";
import {NzInputModule} from "ng-zorro-antd/input";
import {RouterLink} from "@angular/router";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {NzQRCodeModule} from "ng-zorro-antd/qr-code";
import {NzSkeletonModule} from "ng-zorro-antd/skeleton";
import {AsyncPipe, NgIf} from "@angular/common";
import {QrCodeComponent} from "../../../shared/qr-code/qr-code.component";
import {SharedModule} from "../../../shared/shared.module";
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-username-password',
  standalone: true,
  templateUrl: './username-password.component.html',
  styleUrls: ['./username-password.component.sass'],
  imports: [
    NzFormModule,
    NzInputModule,
    RouterLink,
    ReactiveFormsModule,
    NzIconModule,
    NzButtonModule,
    NzDividerModule,
    NzQRCodeModule,
    NzSkeletonModule,
    NgIf,
    AsyncPipe,
    QrCodeComponent,
    SharedModule
  ],
  providers: [UsernamePasswordService]
})
export class UsernamePasswordComponent implements OnInit {
  @Input() onLogin: (username: string, password: string) => void;

  readonly autoLoginQrCode$ = this.usernamePasswordService.autoLoginQrCode$;
  readonly showAuthenticationWithApp = environment.showAuthenticationWithApp;
  readonly hGutter = this.showAuthenticationWithApp ? 16 : 0;

  form: FormGroup;
  passwordVisible = false;

  constructor(
    private fb: FormBuilder,
    private usernamePasswordService: UsernamePasswordService
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  getValidationErrorMessage(controlName: string): string {
    const errors = this.form.get(controlName)?.errors;
    return this.usernamePasswordService.getValidationErrorMessage(errors);
  }

  getAppPaths(pathToRequire: string): AppPaths[] {
    switch (pathToRequire) {
      case 'username':
        return [AppPaths.UsernameLost];
      case 'password':
        return [AppPaths.PasswordLost];
      default:
        return [AppPaths.UsernameLost];
    }
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    const username = this.form.get('username').value;
    const password = this.form.get('password').value;
    this.onLogin(username, password);
  }
}
